// extracted by css-extract-rspack-plugin
export default {"root":"w6RD77"};